/**
 * Выбор города для пользователя — упрощено 27.04.2026 до 3 опций:
 *   - «Все» (cities=[]): пользователь работает во всех городах.
 *   - «Санкт-Петербург» (cities=['Санкт-Петербург']): только этот город.
 *   - «Москва» (cities=['Москва']): только этот город.
 *
 * Раньше был мульти-селект + чекбокс «все кроме». Бизнес-логика упростилась
 * (Сергей 27.04): админу нужны только три варианта. `excludeMode` оставлен
 * в контракте API для обратной совместимости, всегда передаётся `false`.
 *
 * `allCities` параметр оставлен в сигнатуре, не используется (старая логика
 * брала список из клиентов БД). Удалить когда `UserRow` тоже мигрирует.
 */

const CITY_OPTIONS = [
  { value: '', label: 'Все' },
  { value: 'Санкт-Петербург', label: 'Санкт-Петербург' },
  { value: 'Санкт-Петербург 2', label: 'Санкт-Петербург 2' },
  { value: 'Москва', label: 'Москва' },
] as const

type CityValue = (typeof CITY_OPTIONS)[number]['value']

export function CityDropdown({
  selected,
  onSave,
}: {
  selected: string[]
  /** @deprecated с 27.04.2026 не используется (был для «все кроме»). */
  excludeMode?: boolean
  /** @deprecated с 27.04.2026 не используется (раньше — список городов из клиентов). */
  allCities?: string[]
  onSave: (cities: string[], excludeMode: boolean) => void
}) {
  // Текущее значение в дропдауне:
  //   cities=[] → 'Все'
  //   cities=['СПб'|'СПб2'|'Москва'] → этот город
  //   cities=[нечто_иное_legacy] → 'Все' (выбираем первое валидное)
  const current: CityValue = (() => {
    if (selected.length === 0) return ''
    if (selected.includes('Санкт-Петербург 2')) return 'Санкт-Петербург 2'
    if (selected.includes('Санкт-Петербург')) return 'Санкт-Петербург'
    if (selected.includes('Москва')) return 'Москва'
    return ''
  })()

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value as CityValue
    const next = value === '' ? [] : [value]
    onSave(next, false) // excludeMode всегда false в новой модели
  }

  return (
    <select
      value={current}
      onChange={handleChange}
      className="text-xs px-2 py-1 rounded border border-gray-200 hover:border-brand-400 focus:outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 bg-white text-gray-700 cursor-pointer max-w-[180px]"
      aria-label="Город пользователя"
    >
      {CITY_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  )
}
